import { Row, Col, Card, Empty } from "antd"
import { ExclamationCircleFilled, DeleteOutlined, EditOutlined } from "@ant-design/icons"
import { useRecoilValue } from "recoil"
import { inwardPartner } from "../../store/gloabalState"

const SignatoryCard = ({
  mode,
  auths,
  editOpenAuth,
  selectionValue,
  warningDirector,
  showAuthDeleteConfirm,
}) => {
  const partnerState = useRecoilValue(inwardPartner)
  return (
    <div>
      {auths.length ? (
        <Row>
          {auths.map((elem, i) => {
            let dob_
            if (elem.dob !== null && elem.dob !== "null") {
              dob_ = elem?.dob
            }
            return (
              <Col span={12} key={elem?.id}>
                <Card
                  className="directors_card"
                  title={<b>{elem?.name}</b>}
                  style={{
                    width: 400,
                    borderRadius: "5px",
                    border: "0.9px solid rgba(0,0,0,0.3)",
                    overflow: "hidden"
                  }}
                  disabled={mode === 'view' ? true : false}
                  bordered
                  hoverable
                  extra={
                    warningDirector.includes(elem.id) && (
                      <ExclamationCircleFilled
                        style={{
                          color: "red",
                          fontSize: "16px"
                        }}
                      />
                    )
                  }
                  actions={[
                    <DeleteOutlined
                      key={"delete"}
                      style={
                        mode === "view"
                          ? { color: "red", opacity: ".3" }
                          : { color: "red" }
                      }
                      onClick={() => {
                        mode !== 'view' &&
                          showAuthDeleteConfirm(elem, "director")
                      }

                      }
                      disabled={mode === "view"}
                    />,
                    <EditOutlined
                      disabled={mode === 'view' ? true : false}
                      key="edit"
                      onClick={() => {
                        mode !== 'view' &&
                          editOpenAuth(elem)
                      }}
                    />
                  ]}
                >
                  {selectionValue === "outward" ||
                    selectionValue === "both" ? (
                    <>
                      <p>
                        Email: <span>{elem.emailId}</span>
                      </p>
                      <p>
                        DOB: <span>{dob_ && dob_}</span>
                      </p>
                    </>
                  ) : (
                    ""
                  )}
                  <p>
                    PAN: <span>{elem.panNumber}</span>
                  </p>
                  {
                    !partnerState?.includes("payglocal") ?
                      <>
                        <p>
                          Email: <span>{elem.emailId}</span>
                        </p>
                        <p>
                          Nationality: <span>{elem.nationality}</span>
                        </p>
                      </>
                      : ""
                  }
                </Card>
              </Col>
            )
          })}
        </Row>
      ) : (
        <>
          <Empty
            description={
              <span>No Authorised signatories data present</span>
            }
          />
        </>
      )}
    </div>
  )

}

export default SignatoryCard;